type I18nDateFormat = 'EEEMMMDYYYYHHMM' | 'EEEMMMDHHMM' | 'MMMDYYYYHHMM' | 'MMMDYYYY' | 'MMMD'

export function useI18nDateString() {
  const { locale } = useI18n()

  const baseFormatOpts: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short', hour12: false }
  const formatOptsMap: Record<I18nDateFormat, Intl.DateTimeFormatOptions> = {
    EEEMMMDYYYYHHMM: { ...baseFormatOpts, hour: 'numeric', minute: 'numeric', weekday: 'short', year: 'numeric' },
    EEEMMMDHHMM: { ...baseFormatOpts, hour: 'numeric', minute: 'numeric', weekday: 'short' },
    MMMDYYYYHHMM: { ...baseFormatOpts, hour: 'numeric', minute: 'numeric', year: 'numeric' },
    MMMDYYYY: { ...baseFormatOpts, year: 'numeric' },
    MMMD: baseFormatOpts,
  }

  const formatDateWithI18n = (date: Date | string, optionsOrFormat: Intl.DateTimeFormatOptions | I18nDateFormat) => {
    const formatOptions = typeof optionsOrFormat === 'object' ? optionsOrFormat : formatOptsMap[optionsOrFormat]

    if (!formatOptions) {
      throw new Error('Invalid format options')
    }

    return formatI18nDateString(date, locale.value, formatOptions)
  }

  return { formatDateWithI18n }
}
